/**
 * Fallback lazy-loading. Every below-the-fold <img> in the views already has
 * `loading="lazy"`, so this only runs for browsers without it, over the
 * [data-original] attribute the ported markup uses.
 */
export function lazyLoadInit() {
  const targets = Array.prototype.slice.call(document.querySelectorAll('img[data-original]'));
  if (targets.length === 0) return;

  if (!('IntersectionObserver' in window)) {
    targets.forEach((img) => {
      img.src = img.getAttribute('data-original');
    });
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const img = entry.target;
        img.src = img.getAttribute('data-original');
        img.removeAttribute('data-original');
        io.unobserve(img);
      });
    },
    { rootMargin: '200px' },
  );

  targets.forEach((img) => io.observe(img));
}
